import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Button, Link, Typography } from "@mui/material";
import { ReactComponent as OwTextIcon } from "assets/img/ow-text-icon.svg";
import { useOcProperty } from "oc/hooks";

interface MyHrLoginTwoFactorLockedProps {
  onCancel: () => void;
  isMobile: boolean;
}

export const MyHrLoginTwoFactorLocked = ({
  onCancel,
  isMobile,
}: MyHrLoginTwoFactorLockedProps) => {
  const { t } = useTranslation();

  const { data: helpdeskEmail } = useOcProperty({
    resource: "system",
    key: "helpdeskEmail",
  });

  const mailto = `mailto:${helpdeskEmail}`;

  return (
    <Box
      sx={{
        width: isMobile ? "auto" : "304px",
        padding: isMobile ? "0px 24px" : "unset",
      }}
    >
      <OwTextIcon />
      <Typography
        variant="body1"
        sx={{
          marginTop: "36px",
        }}
      >
        {t("MY_HR_ACCOUNT_LOCKED_AFTER_FAILED_ATTEMPTS")}
      </Typography>
      <Box height="36px" />
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <Typography variant="body1">{t("MY_HR_EMAIL")}:</Typography>
        <Box width="5px" />
        <Link
          style={{
            cursor: "pointer",
            fontSize: "16px",
            color: "#CC0033",
            textDecoration: "none",
          }}
          href={mailto}
          onClick={(e) => {
            window.location.href = mailto;
            e.preventDefault();
          }}
        >
          {helpdeskEmail || ""}
        </Link>
      </Box>
      <Button
        variant="text"
        color="secondary"
        fullWidth
        sx={{ color: "#212121", marginTop: "32px" }}
        onClick={onCancel}
      >
        {t("OC_CANCEL")}
      </Button>
    </Box>
  );
};

export default MyHrLoginTwoFactorLocked;
